import { Tooltip } from 'antd';
import React, { ReactNode } from 'react';
import { useTranslate } from 'hooks/use-translation';
import { HoverableSpanWithUnderline, SecondaryText } from '../components';

export const noDataMessageFormatter = (
  message: string | ReactNode,
  translate: ReturnType<typeof useTranslate>,
): ReactNode =>
  translate('reports.project_performance.no_data', {
    a: (chunks) => (
      <Tooltip title={message}>
        <HoverableSpanWithUnderline>{chunks}</HoverableSpanWithUnderline>
      </Tooltip>
    ),
  });

export const noDataRender = (message: string | ReactNode): JSX.Element => (
  <SecondaryText>{message}</SecondaryText>
);
